import { render, staticRenderFns } from "./channelAdPlan.vue?vue&type=template&id=65116c30&scoped=true&"
import script from "./channelAdPlan.vue?vue&type=script&lang=js&"
export * from "./channelAdPlan.vue?vue&type=script&lang=js&"
import style0 from "./channelAdPlan.vue?vue&type=style&index=0&id=65116c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65116c30",
  null
  
)

export default component.exports